import { render, staticRenderFns } from "./SelectAfipTipoComprobante.vue?vue&type=template&id=6091b6fb&"
import script from "./SelectAfipTipoComprobante.vue?vue&type=script&lang=js&"
export * from "./SelectAfipTipoComprobante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports